export default{
  NewUserGroupAdd: 'گروه کاربران جدید اضافه شد',
  UserGroupRemoved: 'گروه کاربران حذف شد',
  UserGroupUpdate: 'گروه کاربران بروزرسانی شد',


  GroupName: 'نام گروه',
  Order: "ترتیب" , 
  Slug: 'Slug',
  Enable: 'فعال',
  Disable: 'غیر فعال'
}